// const DEBUG = true;

import {BUS_SETTINGS_MANAGER_CONFIG_CHANGED} from "../../gd/bus/bus-event-type"

export enum AppSettingsMode {
    CUSTOM        = 'custom',       // not inherited and not template
    INHERITED     = 'inherited',    // inherited from parent folder
    TEMPLATE      = 'template'      // view template/preset is used
}

export const APP_SETTINGS_MODE_CUSTOM       = 'custom'
export const APP_SETTINGS_MODE_INHERITED    = 'inherited'
export const APP_SETTINGS_MODE_TEMPLATE     = 'template'

export const DEFAULT_TEMPLATE_ID            = '_default'
export const LOCAL_INHERITED_TEMPLATE_ID    = '_inheritedLocal'

// const debug = "AppSettings"
const debug = false

export default class AppSettings {

    public localSettings        : any
    public defaultAppSettings   : any
    public _initialConfig       : any

    constructor(appSettingsConfig:any, localSettings:any, defaultAppSettings?:any) {

        // appSettingsConfig - config with settings we store in DB
        // localSettings - initialized local settings instance
        // defaultAppSettings - default settings values

        this.localSettings      = localSettings;
        this.defaultAppSettings = defaultAppSettings;

        // save initial config for changes comparison in isConfigChanged() and to restore values on reset()
        // should be set to some default config in child class if appSettingsConfig is undefined
        this._initialConfig = appSettingsConfig;

        // check if we have local app settings overridden
        let config;
        if (this.localSettings.appSettings) config = this.localSettings.appSettings;
        else                                config = appSettingsConfig;

        // initialize our settings
        this._init(config);
    }

    _init(appSettingsConfig:any) {
        // should be implemented in child class
    }

    loadFromJSON(appSettingsConfig:any) {
        this._init(appSettingsConfig);
    }

    // is called every time appSettings parameter is changed
    _onConfigChanged() {
        this.localSettings.appSettings = this.configToJSON();
        this.localSettings.save();
        gd.bus.triggerEvent(BUS_SETTINGS_MANAGER_CONFIG_CHANGED)
    }

    // reset all parameters to initial values (delete local settings)
    reset(appSettingsConfig?:any) {
        if (appSettingsConfig) this._initialConfig = this.normalizeConfig(appSettingsConfig); // reset to this config if passed

        // DEBUG && console.log("app-settings-proto save called");
        this.localSettings.appSettings = null;
        this.localSettings.save();
        this._init(this._initialConfig);
        gd.bus.triggerEvent(BUS_SETTINGS_MANAGER_CONFIG_CHANGED)
    }

    changeParameters(params: {[paramName:string]:any}) {
        debug && console.log(debug, "changeParameters", params)

        let isChanged = false
        _.mapKeys(params, (value,paramName)=>{

            // @ts-ignore
            if (!_.isEqual(this.localSettings[paramName], value)) {
                // @ts-ignore
                this.localSettings[paramName] = value
                isChanged = true
            }
        })

        if (isChanged) {
            this.localSettings.save()
        }
    }

    // state check
    isConfigChanged() {return !_.isEqual(this.configToJSON(), this.normalizeConfig(this._initialConfig))}

    confirmChanges() {
        this._initialConfig = this.configToJSON()
    }

    configToJSON() {
        return this.normalizeConfig(this);
    }

    normalizeConfig(obj:any) {
        // should be overridden in child class
        return {};
    }
}